// ANSI Shadow Effect
export default function EasterEggs() {
    console.log(`
██████╗  ██████╗ ██╗     █████╗  ██████╗ ███████╗███╗   ██╗ ██████╗██╗   ██╗
██╔══██╗██╔═══██╗██║    ██╔══██╗██╔════╝ ██╔════╝████╗  ██║██╔════╝╚██╗ ██╔╝
██████╔╝██║   ██║██║    ███████║██║  ███╗█████╗  ██╔██╗ ██║██║      ╚████╔╝ 
██╔══██╗██║   ██║██║    ██╔══██║██║   ██║██╔══╝  ██║╚██╗██║██║       ╚██╔╝  
██║  ██║╚██████╔╝██║    ██║  ██║╚██████╔╝███████╗██║ ╚████║╚██████╗   ██║   
╚═╝  ╚═╝ ╚═════╝ ╚═╝    ╚═╝  ╚═╝ ╚═════╝ ╚══════╝╚═╝  ╚═══╝ ╚═════╝   ╚═╝   

               Return On Investment
`);


    console.log("Curious? contact mohameddhamdy407@gmail.com to join us")
}